export default __webpack_public_path__ + "static/three-8d59b39cf27247e430b7d33b74421488.png";